import {
  DEFAULT_VIEWPORT_WALLSIZE,
  DEFAULT_TOUCH_POINT_WIDTH,
  DEFAULT_TOUCH_POINT_START_COLUMN
} from '../../../../../store/cabinetVisualizer/selectors';
import { getPxInInches, inchesToPxs } from '../../../../../utils/wall-size-utils';

const DEFAULT_WIDTH = DEFAULT_VIEWPORT_WALLSIZE.Columns;
const DEFAULT_HEIGHT = DEFAULT_VIEWPORT_WALLSIZE.Rows;

export const zoomLevels = [0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0];
export const mobileZoomOffset = 0.20;
export const defaultZoom = 1;

export const mobileBreakpoint = 500;
export const isMobileVisualizer = (width) => width <= mobileBreakpoint;

export const getOccupiedWidth = (products) => {
  if (!products || products.length === 0) {
    return 0;
  }
  const minColumn = Math.min(...products.map((cabinet) => cabinet.Origin.Column));
  const maxColumn = Math.max(...products.map((cabinet) => cabinet.Origin.Column + cabinet.Origin.Width));

  const occupiedWidth = maxColumn - minColumn;
  return occupiedWidth;
};

export const getOccupiedHeight = (products) => {
  if (!products || products.length === 0) {
    return 0;
  }
  const minRow = Math.min(0, ...products.map((cabinet) => cabinet.Origin.Row));
  const maxRow = Math.max(
    DEFAULT_HEIGHT,
    ...products.map((cabinet) => cabinet.Origin.Row + cabinet.Origin.Height)
  );
  return maxRow - minRow;
};

export const handleAutoZoom = (width, products, direction, enableTouchPointsOnBothSides) => {
  if (!products || products.length === 0) {
    return defaultZoom;
  }
  const occupiedWidth = getOccupiedWidth(products);
  const pxInInches = getPxInInches(width, DEFAULT_WIDTH);
  const touchPointWidthInPx = inchesToPxs(DEFAULT_TOUCH_POINT_WIDTH, pxInInches);

  const maxWidth = DEFAULT_VIEWPORT_WALLSIZE.Columns;
  const widthInPx = inchesToPxs(maxWidth, pxInInches);
  const totalWidthInInches = !enableTouchPointsOnBothSides
    ? occupiedWidth + DEFAULT_TOUCH_POINT_WIDTH + DEFAULT_TOUCH_POINT_START_COLUMN
    : occupiedWidth + (DEFAULT_TOUCH_POINT_WIDTH + DEFAULT_TOUCH_POINT_START_COLUMN) * 2;

  const totalWidthInPx = inchesToPxs(totalWidthInInches, pxInInches);

  let scale = defaultZoom;
  if (products && products.length > 0
    && totalWidthInPx > widthInPx) {
    scale = (widthInPx / totalWidthInPx) * defaultZoom;
  }

  // Also account for vertical overflow (e.g., tall wall cabinets or pantries
  // that extend above the standard wall zone). The viewport has a 4:3 aspect
  // ratio, so viewportHeight ≈ width * 0.75. Scale down further if the total
  // vertical extent (wall + floor + margin + overflow) exceeds that.
  const occupiedHeight = getOccupiedHeight(products);
  if (occupiedHeight > DEFAULT_HEIGHT) {
    const MARGIN_TOP_PX = 60;
    const floorHeightInInches = isMobileVisualizer(width) ? 24 : 12;
    const totalHeightInInches = occupiedHeight + floorHeightInInches;
    const heightInPx = inchesToPxs(DEFAULT_HEIGHT, pxInInches);
    const viewportHeight = heightInPx + inchesToPxs(floorHeightInInches, pxInInches) + MARGIN_TOP_PX;
    const totalHeightInPx = inchesToPxs(totalHeightInInches, pxInInches) + MARGIN_TOP_PX;
    const verticalScale = (viewportHeight / totalHeightInPx) * defaultZoom;
    scale = Math.min(scale, verticalScale);
  }

  if (isMobileVisualizer(width) && totalWidthInPx + touchPointWidthInPx <= width && scale === defaultZoom) {
    return defaultZoom + mobileZoomOffset;
  }
  return scale;
};
